export const infoConfig = {
	emailAuthToken: 'b8dba9a5-d212-4c77-8907-23307620de5d',
	email: 'info@studio31.hr',
	phone: '+385 98 92 754 92',
};
